import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing }: Theme) => createStyles({
  linkContainer: {
    marginBottom: spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  link: {
    display: 'inline-flex',
  },
  text: {
    marginTop: '-3px',
  },
  icon: {
    width: spacing(3),
    height: spacing(3),
  },
});

export default styles;
